import { useSelector, useDispatch } from "react-redux";
import { fullName } from "../../../../../../services/utilities/index.js";
import { MDBBadge, MDBBtn, MDBBtnGroup, MDBIcon } from "mdbreact";
import { Services } from "../../../../../../services/fakeDb/index.js";
import { SetTASK } from "../../../../../../services/redux/slices/diagnostics/laboratory/validator.js";
import {
  getVisibleChemistryPackages,
  shouldHideChemistryFromCurrentMachine,
} from "../../../../../../services/utilities/a15Workarea";

const Tasks = ({ key, form, obj, index, customer }) => {
  const { activePlatform } = useSelector(({ auth }) => auth),
    { collections } = useSelector(({ preferences }) => preferences),
    dispatch = useDispatch();

  if (
    form === "Chemistry" &&
    shouldHideChemistryFromCurrentMachine(obj)
  ) {
    return null;
  }

  const handleLabPrint = (task) => {
    const { packages: pkgs = [] } = task;
    const services = collections.filter(({ id }) => task.services.includes(id));
    const taskData = { ...task, services };
    localStorage.setItem("taskPrintout", JSON.stringify(taskData));
    const URL = `${window.location.origin}/printout/laboratory/${
      Array.isArray(pkgs) && pkgs?.includes(176) ? "drugtest" : "task"
    }`;
    const features = "top=100px,left=100px,width=794px,height=1123px";

    setTimeout(() => {
      const printWindow = window.open(
        URL,
        "Laboratory Task Printout",
        features
      );
      if (printWindow) printWindow.focus();
    }, 100);
  };

  const {
    packages = [],
    hasDone = false,
    remarks = "",
    signatories = [],
  } = obj;

  const _packages =
    form === "Chemistry"
      ? getVisibleChemistryPackages(obj)
      : packages && typeof packages === "object"
      ? Array.isArray(packages)
        ? packages
        : Object.keys(packages).map((k) => Number(k))
      : packages
      ? [packages]
      : [];

  const task = {
    ...obj,
    _id: obj._id || `${form}-${index}-${key}`,
    key: `${form}-${index}-${key}`,
    form,
    patient: customer,
    generateHealthyClient: [
      "Urinalysis",
      "Parasitology",
      "Xray",
      "Ultrasound",
    ].includes(form),
    hasDone,
    remarks,
  };

  const handleEntry = () => dispatch(SetTASK({ task }));

  const isEmptyEntry = _packages.length === 0;

  const done =
    !!signatories.length && signatories[0] && signatories[1] && hasDone;
  return (
    <tr key={task.key} className={hasDone ? "table-active" : ""}>
      <td>{index}</td>
      <td>
        <strong>
          {signatories[0]?.fullName && fullName(signatories[0].fullName)}
        </strong>
      </td>

      <td>
        <strong>
          {signatories[1]?.fullName && fullName(signatories[1].fullName)}
        </strong>
      </td>

      <td>{form}</td>
      <td>
        {isEmptyEntry ? (
          <MDBBadge color="danger" pill>
            No services
          </MDBBadge>
        ) : (
          Services.whereIn(_packages).map(({ abbreviation }, i) => (
            <MDBBadge pill key={`${task.key}-service-${i}`} className="pt-1">
              {abbreviation}
            </MDBBadge>
          ))
        )}
      </td>
      <td>
        <MDBBtnGroup>
          <MDBBtn
            onClick={handleEntry}
            color={hasDone ? "info" : "primary"}
            size="sm"
            className="py-1 px-2 m-0"
          >
            <MDBIcon icon={hasDone ? "pencil-alt" : "list-alt"} />
          </MDBBtn>

          {done && (
            <MDBBtn
              onClick={() => {
                const selectedTask = {
                  ...task,
                  branchId: activePlatform?.branch,
                  services: _packages,
                  signatories,
                  isPrint: true,
                };
                handleLabPrint(selectedTask);
              }}
              color="warning"
              size="sm"
              className="py-1 px-2 m-0"
            >
              <MDBIcon icon="print" />
            </MDBBtn>
          )}
        </MDBBtnGroup>
      </td>
    </tr>
  );
};

export default Tasks;
